export const Source = Object.freeze(
{
    CHART: "Chart",
    DATASET_DOWNLOAD: "Dataset download",
})